export const compressImage = async (file, targetKB = 1200) => {
    const img = await createImageBitmap(file);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = img.width;
    canvas.height = img.height;
    ctx.drawImage(img, 0, 0);

    let quality = 0.9;
    let blob;
    while (quality > 0.1) {
        blob = await new Promise(res => canvas.toBlob(res, "image/jpeg", quality));
        if (!blob || blob.size / 1024 <= targetKB) break;
        quality -= 0.05;
    }
    if (!blob) throw new Error("Image compression failed");
    return blob;
};

export const blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};